<template>
  <div class="panel panel-default passenger-item" role="listitem">
    <div class="panel-heading">
      <h2 class="panel-title">
        {{ $t("passenger") }} {{ index + 1 }}:
        <strong>{{ passengersItem.name }}</strong>
      </h2>
    </div>
    <div class="panel-body">
      <div class="col-sm-6">
        <ValidationProvider :rules="
          'required:' +
          $t('passenger') +
          ' ' +
          (index + 1) +
          ' ' +
          $t('fname') +
          ',#passenger' +
          index +
          'firstName'
        " v-slot="{ errors, ariaInput, ariaMsg }" slim>
          <div :class="{ 'form-group': true, 'has-error': errors.length }">
            <label :for="'passenger' + index + 'firstName'">{{
                $t("fname")
            }}</label>
            <input type="text" :id="'passenger' + index + 'firstName'" v-model="firstName" class="form-control"
              v-bind="ariaInput" />
            <span class="label label-danger form-error" v-if="errors.length" v-bind="ariaMsg">
              <strong>
                <span class="prefix">{{ $t("errorPrefix") }}</span>
                <span v-html="errors[0]"></span>
              </strong>
            </span>
          </div>
        </ValidationProvider>
      </div>
      <div class="col-sm-6">
        <ValidationProvider :rules="
          'required:' +
          $t('passenger') +
          ' ' +
          (index + 1) +
          ' ' +
          $t('lname') +
          ',#passenger' +
          index +
          'lastName'
        " v-slot="{ errors }" slim>
          <div :class="{ 'form-group': true, 'has-error': errors.length }">
            <label :for="'passenger' + index + 'lastName'">{{
                $t("lname")
            }}</label>
            <input type="text" :id="'passenger' + index + 'lastName'" v-model="lastName" class="form-control" />
            <span class="label label-danger form-error" v-if="errors.length">
              <strong>
                <span class="prefix">{{ $t("errorPrefix") }}</span>
                <span v-html="errors[0]"></span>
              </strong>
            </span>
          </div>
        </ValidationProvider>
      </div>
      <div class="clearfix"></div>
      <div class="col-sm-6">
        <ValidationProvider :rules="
          'required:' +
          $t('passenger') +
          ' ' +
          (index + 1) +
          ' ' +
          $t('email') +
          ',#passenger' +
          index +
          'email' +
          '|email'
        " v-slot="{ errors }" mode="passive" slim>
          <div :class="{ 'form-group': true, 'has-error': errors.length }">
            <label :for="'passenger' + index + 'email'">{{
                $t("email")
            }}</label>
            <input type="text" :id="'passenger' + index + 'email'" v-model="email" class="form-control" />
            <span class="label label-danger form-error" v-if="errors.length">
              <strong>
                <span class="prefix">{{ $t("errorPrefix") }}</span>
                <span v-html="errors[0]"></span>
              </strong>
            </span>
          </div>
        </ValidationProvider>
        <div class="form-group" v-for="qtySSR in getQtySSRS" :key="qtySSR._id">
          <ValidationProvider :rules="{
            required: {
              fieldLabel: getLexiconTranslation(qtySSR.lexiconKeys.name),
              fieldId: '#passenger[' + index + '][' + qtySSR._id + ']',
            },
          }" name="baggageSSR" v-slot="{ errors }" slim>
            <label :for="'passenger[' + index + '][' + qtySSR._id + ']'">{{
                getLexiconTranslation(qtySSR.lexiconKeys.name)
            }} <span v-if="ssrCanBeSelected(qtySSR.cutoffTime)"><br>{{ $t('ssrUnavailableCutOff', {
    timeInHours:
      qtySSR.cutoffTime / 60
  })
}}</span></label>
            <select :id="'passenger[' + index + '][' + qtySSR._id + ']'"
              @change="ssrChange($event, qtySSR.name, qtySSR._id)" v-model="baggageSSR" class="form-control"
              :disabled="ssrCanBeSelected(qtySSR.cutoffTime)">
              <option value="" selected>{{ $t('choose_qty') }} {{
                  getLexiconTranslation(qtySSR.lexiconKeys.pluralUnitDescription)
              }}...</option>
              <template v-for="(n, index) in qtySSR.maxQty + 1">
                <template v-if="index == 0">
                  <option :value="index" :key="index">{{
                      getLexiconTranslation(qtySSR.lexiconKeys.emptyUnitDescription)
                  }}</option>
                </template>
                <template v-if="index > 0 && index <= qtySSR.maxWithoutCharge">
                  <option :value="index" :key="index">{{ index }} {{
                      getLexiconTranslation(qtySSR.lexiconKeys.pluralUnitDescription)
                  }} {{ $t('no_charge') }}</option>
                </template>
                <template v-if="index > 0 && index > qtySSR.maxWithoutCharge">
                  <option :value="index" :key="index">{{ index }} {{
                      getLexiconTranslation(qtySSR.lexiconKeys.pluralUnitDescription)
                  }} {{ qtySSR.feeType }}{{
    qtySSR.fee * (index - qtySSR.maxWithoutCharge)
}}</option>
                </template>
              </template>
            </select>
            <span class="label label-danger form-error" v-if="errors.length">
              <strong>
                <span class="prefix">{{ $t("errorPrefix") }}</span>
                <span v-html="errors[0]"></span>
              </strong>
            </span>
          </ValidationProvider>
        </div>
      </div>
      <div class="col-sm-6">
        <fieldset>
        <legend>{{ $t("adServices") }}</legend>
        <div class="form-group additional-services">
          <div v-for="boolSSR in getBoolSSRS" :key="boolSSR._id" class="form-checkbox">
            <input type="checkbox" :id="'passenger[' + index + '][' + boolSSR._id + ']'" v-model="ssrbool"
              :value="{ _id: boolSSR._id, name: boolSSR.name, quantity: '1' }"
              :disabled="ssrCanBeSelected(boolSSR.cutoffTime)" class="sr-only" />
            <label :for="'passenger[' + index + '][' + boolSSR._id + ']'"
              :class="ssrCanBeSelected(boolSSR.cutoffTime) ? 'disabled' : ''">{{
                  getLexiconTranslation(boolSSR.lexiconKeys.name)
              }} <span v-if="ssrCanBeSelected(boolSSR.cutoffTime)"><br>{{ $t('ssrUnavailableCutOff', {
    timeInHours:
      boolSSR.cutoffTime / 60
  })
}}</span></label>
          </div>
          <div v-for="multiSSR in getMultiSSRS" :key="multiSSR._id" class="form-group">
            <label :for="'passenger[' + index + '][' + multiSSR._id + ']'">{{
                getLexiconTranslation(multiSSR.lexiconKeys.description)
            }} <span v-if="ssrCanBeSelected(multiSSR.cutoffTime)"><br>{{ $t('ssrUnavailableCutOff', {
    timeInHours:
      multiSSR.cutoffTime / 60
  })
}}</span></label>
            <select :id="'passenger[' + index + '][' + multiSSR._id + ']'"
              @change="ssrChange($event, multiSSR.name, multiSSR._id)" class="form-control"
              :disabled="ssrCanBeSelected(multiSSR.cutoffTime)">
              <option value="" selected>{{ getLexiconTranslation(multiSSR.lexiconKeys.emptyMultivalueDescription) }}
              </option>
              <option v-for="multivalue in multiSSR.lexiconKeys.multivalues" :key="multivalue"
                :value="getLexiconTranslation(multivalue)">{{ getLexiconTranslation(multivalue) }}</option>
            </select>

          </div>
        </div>
        </fieldset>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import i18n from "../i18n";
import { ValidationProvider, extend } from "vee-validate";
import { required, email } from "vee-validate/dist/rules";

// No message specified.
extend("email", {
  ...email,
  message: "Please enter a valid email",
});

// Override the default message.
extend("required", {
  ...required,
  params: ["fieldLabel", "fieldId"],
  message: (fieldName, placeholders) => {
    //return `The <a href="${placeholders.fieldId}">${placeholders.fieldLabel}</a> field is required.`;
    let transMessage = i18n.t("dynamicError", {
      fieldId: placeholders.fieldId,
      fieldLabel: placeholders.fieldLabel,
    });
    return transMessage;
  },
});

export default {
  props: ["passengersItem", "index"],
  components: {
    ValidationProvider,
  },
  data() {
    return {
      firstName: "",
      lastName: "",
      email: "",
      ssrs: [],
      ssrbool: [],
      baggageSSR: "",
    };
  },
  computed: {
    fares() {
      return this.$store.state.fares;
    },
    departureTripItem() {
      return this.$store.state.departureTripItem;
    },
    filledSSRS() {
      return this.ssrs.concat(this.ssrbool);
    },
    passengerObject() {
      return {
        firstName: this.firstName,
        lastName: this.lastName,
        email: this.email,
        fareId: this.passengersItem.fareId,
        fare: this.passengersItem.name,
        fareClassIds: {
          outbound: this.$store.state.departureFareClass,
          return: this.$store.state.returnFareClass,
        },
        ssrs: this.filledSSRS,
        seats: [],
      };
    },
    ...mapGetters(["getLexiconTranslation", "getBoolSSRS", "getQtySSRS", "getMultiSSRS"])
  },
  watch: {
    passengerObject: function (newInfo) {
      this.$store.commit("setPassenger", {
        index: this.index,
        passengerObject: newInfo,
      });
    },
  },
  methods: {
    ssrCanBeSelected: function (ssr) {
      let ssrCutOff = ssr * 60 * 1000;
      let tripPurchasable = Date.parse(this.departureTripItem.purchasableUntil);
      let dateNow = Date.now();
      return (dateNow > (tripPurchasable - ssrCutOff) && ssrCutOff !== 0);
    },
    pushToArray: function (arr, obj) {
      const index = arr.findIndex((e) => e._id === obj._id);

      if (index === -1) {
        arr.push(obj);
      } else {
        Vue.set(arr, index, obj);
        //arr[index] = obj;
      }
    },
    ssrChange: function (event, ssrName, ssrId) {
      if (isNaN(event.target.value)) {
        this.pushToArray(this.ssrs, {
          _id: ssrId,
          name: ssrName,
          quantity: 1,
          selectedMultivalues: [event.target.value],
        });
      } else {
        this.pushToArray(this.ssrs, {
          _id: ssrId,
          name: ssrName,
          quantity: event.target.value,
        });

      }

    },
    // getLexiconTranslation: function(key){
    //   return this.$store.getters.getLexiconTranslation(key);
    // }
  },
  filters: {},
  mounted() {
    // if (this.$store.state.passengers) {
    //   this.firstName = this.$store.state.passengers[this.index].firstName;
    //   this.lastName = this.$store.state.passengers[this.index].lastName;
    //   this.email = this.$store.state.passengers[this.index].email;
    // }
  },
  created() { },
};
</script>
<style lang="scss">
.panel.panel-default {
  border-radius: 2px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
  border-width: 0px;

  .panel-heading {
    border-radius: 2px 2px 0 0;
    background-color: #E2EDFC;
    color: $brand-primary;

    .panel-title {
      font-weight: 300;
      font-size: 28px;
      padding-left: 15px;
      text-transform: initial;
    }
  }
}

.passenger-item {
  label {
    font-weight: 300;
    font-size: 15px;
    color: #757070;
  }
  legend{
    font-weight: 300;
    font-size: 15px;
    color: #757070;
    border-bottom:unset;
    margin-bottom:5px;
  }
  .form-control {
    background-color: #cecece;
    color: #333;
  }

  .additional-services {
    border: 1px solid #cecece;
    border-radius: 15px;
    padding: 20px;
  }

  .form-checkbox {
    &:focus-within {
      label {
        outline: 2px dashed $brand-primary;
        outline-offset: 3px;
      }
    }

    input {
      opacity: 0;
    }

    input[type="checkbox"]:checked+label::after {
      position: absolute;
      top: 5px;
      left: 5px;
      width: 15px;
      height: 15px;
      border-radius: 15px;
      background-color: $brand-highlight;
      content: "";
      display: block;
      position: absolute;
    }

    label {
      color: #757070;
      font-size: 18px;
      font-weight: 300;
      font-family: "Roboto", sans-serif;
      position: relative;
      padding-left: 30px;

      &::before {
        position: absolute;
        top: 0px;
        left: 0px;
        content: "";
        border: 2px solid $brand-highlight;
        width: 25px;
        height: 25px;
        display: block;
        border-radius: 20px;
      }

      &.disabled {
        cursor: not-allowed;
      }

      &.disabled::before {
        border: 2px dashed $brand-highlight;
      }
    }
  }
}
</style>